import { Box, Stack, Typography } from '@mui/material'
import React from 'react'
import { InputLabelStyled, ParentSelectBox } from '../../DiabeticForm/sub-form-sections/PresentingComplaintSection'
import RadioButtonController from '../../../../components/RadioButtonController/RadioButtonController';
import { footAmputationOptions } from './formFootOptions';
import CheckboxController from '../../../../components/CheckboxSelector/CheckboxSelector';
import { CustomInputLable, InputContainer, ParentContainerSection } from '../FootForm';


const FootAmputation = (props) => {
    const {control, errors, getValues} = props

    const footAmputations = [
        {labelName:"Left",
        form_field_name:"foot_amputation.amputation_left",
         option:footAmputationOptions },

        {labelName:"Right",
        form_field_name:"foot_amputation.amputation_right",
        option:footAmputationOptions },
    ]


   return (
    <ParentContainerSection heading="Section I – History of foot amputation">
               {footAmputations.length && footAmputations.map((item,index)=>(
                <InputContainer  >
          <CustomInputLable>{item.labelName}</CustomInputLable>
           
                    <CheckboxController
                                name={item.form_field_name}
                                isRow={true}
                                isMultiCheckbox={true}
                                control={control}
                                errors={errors}
                                options={item.option}
                                isHorizantalPadding={true}
                                isDisabled
                            />
                    </InputContainer>
        ))}
        </ParentContainerSection>
  )
}

export default FootAmputation